import { reloadEpic } from './state/reload.epic';

export const mainEpics = [reloadEpic];
